import { Button, styled } from "@mui/material";

import theme from "Theme/AppTheme";

const AcxClickableCell = styled(Button)({
    color: theme.palette.gray[700],
    fontWeight: 400,
    fontSize: "12px",
    height: "100%",
    width: "100%",
    justifyContent: "flex-start",
    verticalAlign: "unset",
    textDecoration: "underline",
    padding: 0,

    "&:hover": {
        textDecoration: "underline",
    },
});

export default AcxClickableCell;
